import React, { SyntheticEvent, useMemo, useState } from 'react';

import { LenderInput, RegisteredUser } from '../../../api-client';
import { createRegistrationManager } from '../../../di';
import { useEffectOnUpdate, useErrorCallback } from '../../../hooks';
import { Errors as ValidationErrors, getRickAiMarketingData, getYMClientId } from '../../../utils/';
import { AuthInput } from '../../../views/auth/Enter/Enter';
import { Button, InputErrors, InputPassword, PrimaryButton } from '../../common';
import { PrimaryButtonColor } from '../../common/buttons/decorators/PrimaryButton/PrimaryButton';

type Props = {
  input: AuthInput;
  onRegister: () => void;
};

type PasswordErrors = {
  password?: ValidationErrors;
  confirmPassword?: ValidationErrors;
};

const CreatePassword = ({ input, onRegister }: Props) => {
  const [errors, setErrors] = useState<PasswordErrors>({});
  const [_, setError] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const referrerCode = localStorage.getItem('referral');

  const premium = localStorage.getItem('premium');
  const lenderInput = useMemo((): LenderInput => {
    const lenderInput: LenderInput = { phone: input.phone, password: input.password };
    if (referrerCode) {
      return { ...input, referrerCode };
    }
    return lenderInput;
  }, [input]);

  const validateForm = () => {
    const errors: PasswordErrors = {};
    if (!input.password) {
      errors.password = ['Пароль обязателен для ввода'];
    }
    if (input.password !== confirmPassword) {
      errors.confirmPassword = ['Пароли не совпадают'];
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffectOnUpdate(() => {
    validateForm();
  }, [input.password, confirmPassword]);

  const handleError = useErrorCallback();

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    if (validateForm()) {
      const manager = createRegistrationManager();
      const ymClientId = getYMClientId();
      const rickAiMarketingData = getRickAiMarketingData();
      try {
        const user: RegisteredUser = await manager.registerLender({
          ...lenderInput,
          ymClientId,
          premiumAvailable: !!premium,
          marketingData: rickAiMarketingData,
        });
        if (user) {
          onRegister();
        }
      } catch (err: any) {
        if (err instanceof Error) {
          await handleError(err);
          setError(err.message);
        }
      }
    }
  };
  return (
    <div>
      <div>Придумайте свой пароль</div>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__group">
          <InputPassword
            password={input.password}
            onInput={input.setPassword}
            title="Пароль"
            id="password"
          />
          {errors.password && <InputErrors errors={errors.password} />}
        </div>
        <div className="form__group">
          <InputPassword
            password={confirmPassword}
            onInput={setConfirmPassword}
            title="Повторите пароль"
            id="password-confirm"
          />
          {errors.confirmPassword && <InputErrors errors={errors.confirmPassword} />}
        </div>
        <div className="form__group">
          <PrimaryButton expanded={true} large={true} color={PrimaryButtonColor.GREEN}>
            <Button type="submit">Отправить</Button>
          </PrimaryButton>
        </div>
      </form>
    </div>
  );
};

export default CreatePassword;
